import React from "react"

type Props = {
  title: string
  width: number
  height: number
  url: string
  allowFullScreen?: boolean
}

const Video = ({
  title,
  width,
  height,
  url,
  allowFullScreen = true,
}: Props) => {
  return (
    <iframe
      title={title}
      width={width}
      height={height}
      src={url}
      allowFullScreen={allowFullScreen}
      sandbox="allow-same-origin allow-scripts allow-popups"
    />
  )
}

export default Video
